import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import { reduxBatch } from '@manaflair/redux-batch'
import { getRoofState, getWallState } from '../../../store/slices/selectors'
import {
  jobSettingsActions,
  settingsActions,
  roofActions,
  wallActions,
} from '../../../store/slices'

import { countryOptions, defaultValues } from '../../../common/json/common.json'

import { ButtonGroup, Modal } from '../../../../../components'

import { useModal } from '../../../../../utils/hooks'
import { COUNTRY } from '../../../../../utils/constants'

const CountrySelection = ({ country }) => {
  const dispatch = useDispatch()
  const applicationType = useSelector((state) => getWallState(state).applicationType)
  const roofMemberType = useSelector((state) => getRoofState(state).memberType)
  const wallMemberType = useSelector((state) => getWallState(state).memberType)

  const [show, toggleModal] = useModal(false)

  const countryIcon = useMemo(() => {
    return countryOptions.find((element) => element.value === country).imgSrc || ''
  }, [country])

  const handleSelectCountry = (name, value) => {
    const updatedJobSettings = { ...defaultValues.jobSettings[applicationType][value] }
    const updatedRoof = {
      ...(defaultValues.roof[roofMemberType][applicationType] ??
        defaultValues.roof[roofMemberType].default),
    }
    const updatedWall = { ...defaultValues.wall[wallMemberType] }

    reduxBatch([
      dispatch(settingsActions.updateCalculation({ [name]: value, isUSA: value === COUNTRY.USA })),
      dispatch(
        jobSettingsActions.updateCalculation({
          upliftLoadDurationType: updatedJobSettings.upliftLoadDurationType,
          downloadDurationType: updatedJobSettings.downloadDurationType,
        }),
      ),
      dispatch(roofActions.modifyCalculation({ name: 'type', value: updatedRoof.type })),
      dispatch(wallActions.modifyCalculation({ name: 'type', value: updatedWall.type })),
    ])
    toggleModal()
  }

  return (
    <div>
      <a role="button" onClick={toggleModal} className="btn -round -country">
        <img src={countryIcon} />
      </a>

      <Modal
        show={show}
        onHide={toggleModal}
        className="-country-selector"
        header={
          <Modal.Header closeButton>
            <h3>Select Your Country</h3>
          </Modal.Header>
        }
      >
        <ButtonGroup
          className="buttonGroup row -skinny -subAppSelector"
          colClassName="col-xxs-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 -skinny"
          name="country"
          value={country}
          options={countryOptions}
          onChange={handleSelectCountry}
        />
      </Modal>
    </div>
  )
}

CountrySelection.propTypes = {
  country: PropTypes.string.isRequired,
}

export default CountrySelection
